import { useWorkspace, useCurrentWorkspace, useWorkspaceSwitcher } from '../contexts/WorkspaceContext';

// Re-export workspace hooks for easier imports
export { 
  useWorkspace, 
  useCurrentWorkspace, 
  useWorkspaceSwitcher 
};

// Hook that provides workspace ID for API calls (backward compatibility)
export const useWorkspaceId = (): string | null => {
  const { currentWorkspace } = useWorkspace();
  return currentWorkspace;
};

// Hook that checks if workspace is initialized
export const useWorkspaceInitialized = (): boolean => {
  const { isInitialized } = useWorkspace();
  return isInitialized;
};

export default useWorkspace;